export default __webpack_public_path__ + "static/media/05.c0dd548c.jpg";